import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { X, Download, Loader2, FileWarning } from "lucide-react";

export default function PreviewDialog({ doc, onClose }) {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let objectUrl;
    (async () => {
      try {
        const res = await api.get(`/documents/${doc.id}/preview`, { responseType: "blob" });
        const ct = res.headers["content-type"] || doc.content_type || "";
        objectUrl = window.URL.createObjectURL(new Blob([res.data], { type: ct }));
        setType(ct); setUrl(objectUrl);
      } catch { toast.error("Anteprima non disponibile"); }
      finally { setBusy(false); }
    })();
    return () => { if (objectUrl) window.URL.revokeObjectURL(objectUrl); };
  }, [doc.id]);

  const isPdf = type.includes("pdf");
  const isImg = type.startsWith("image/");
  const download = () => { const a = document.createElement("a"); a.href = url; a.download = doc.original_filename; a.click(); };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg border border-slate-200 shadow-xl w-full max-w-5xl h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="preview-dialog">
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <div className="min-w-0">
            <div className="font-display font-semibold truncate">{doc.nome}</div>
            <div className="text-xs text-slate-500 font-mono truncate">{doc.categoria} · {doc.original_filename}</div>
          </div>
          <div className="flex items-center gap-1">
            {url && <button onClick={download} data-testid="preview-download" className="inline-flex items-center gap-1 text-sm text-blue-700 hover:bg-blue-50 px-3 py-1.5 rounded-lg"><Download size={15} /> Scarica</button>}
            <button onClick={onClose} data-testid="preview-close" className="p-1.5"><X size={20} /></button>
          </div>
        </div>
        <div className="flex-1 bg-slate-100 overflow-auto flex items-center justify-center">
          {busy ? <Loader2 className="animate-spin text-slate-400" size={28} /> :
            !url ? <div className="text-slate-500 text-sm">Impossibile caricare il file.</div> :
            isPdf ? <iframe title="Anteprima" src={url} className="w-full h-full" data-testid="preview-pdf" /> :
            isImg ? <img src={url} alt={doc.nome} className="max-w-full max-h-full object-contain" data-testid="preview-image" /> :
            <div className="text-center text-slate-600 p-8">
              <FileWarning size={36} className="mx-auto mb-3 text-slate-400" />
              <p className="text-sm">Anteprima non disponibile per questo formato.</p>
              <button onClick={download} className="mt-3 px-4 py-2 bg-slate-900 text-white rounded-lg text-sm">Scarica il file</button>
            </div>}
        </div>
      </div>
    </div>
  );
}
